import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../shared/api/axios-instance';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { CampaignRequestDto } from '../dtos/campaign-request.dto';
import { CampaignRequestModel } from '../models/campaign-request.model';
import { mapCampaignRequestModelToCampaignRequestDto } from '../utils/mapping/mapping.util';

export const createCampaign: AsyncThunk<
  number,
  CampaignRequestModel,
  Record<string, unknown>
> = withMandant<CampaignRequestModel, number>(
  Endpoints.CAMPAIGNS_BY_MANDANT_ID,
  'campaigns/create-campaign',
  async ({ args, endpoint }) => {
    if (!args) {
      return new Promise(resolve => resolve(0));
    }

    const requestDto: CampaignRequestDto =
      mapCampaignRequestModelToCampaignRequestDto(args);

    const { data }: AxiosResponse<number> = await axiosInstance.post(
      endpoint,
      requestDto,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return data;
  }
);
